module.exports = __webpack_public_path__ + "static/media/medzing.862aaf2a.jpg";